exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".start-from-last-slide .modal-content h3{font-family:brandon-grotesque,Helvetica,Arial,sans-serif;padding:1em 0;margin:0}.start-from-last-slide .btn{width:100%;white-space:normal;min-height:4em;text-transform:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/autoprefixer-loader?browsers=last 2 version!./~/sass-loader?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./src/views/dashboard/startFromLastSlideModal.scss
// module id = 1297
// module chunks = 2